import { apiClient } from '@/api/client';
import { API_ENDPOINTS } from '@/api/endpoints';
import type { ProjectCreate, ProjectResponse, ProjectUpdate } from '@/api/types';

export const projectsService = {
  list: () =>
    apiClient.get<ProjectResponse[]>(API_ENDPOINTS.PROJECTS.LIST).then((r) => r.data),
  /** A plain project: no recommendations, no credits (the existing-hardware
   *  path's launch dialog creates its project this way). */
  create: (body: ProjectCreate) =>
    apiClient.post<ProjectResponse>(API_ENDPOINTS.PROJECTS.LIST, body).then((r) => r.data),
  detail: (id: string) =>
    apiClient.get<ProjectResponse>(API_ENDPOINTS.PROJECTS.DETAIL(id)).then((r) => r.data),
  update: (id: string, body: ProjectUpdate) =>
    apiClient.put<ProjectResponse>(API_ENDPOINTS.PROJECTS.DETAIL(id), body).then((r) => r.data),
  remove: (id: string) =>
    apiClient.delete(API_ENDPOINTS.PROJECTS.DETAIL(id)).then((r) => r.data),
  refreshRecommendations: (id: string) =>
    apiClient.post(API_ENDPOINTS.PROJECTS.REFRESH_RECOMMENDATIONS(id)).then((r) => r.data),
};
